
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:getShopifyProductData:complete', function(event){
    setTimeout(function(){ 
      Flits(".flits-product-card").each(function(index,ele){
        let pselect = Flits(this).find('span.select'); 
        if(Flits(pselect).length){
          let tmp = Flits(this).find('select').clone();
          Flits(pselect).remove(); Flits(this).find('.flits-select-row').append(tmp) 
        } }); 
    },2000);
  });
  Flits(document).on('Flits:navigation:Before', function(event){
    if(event.detail.el == '#order'){
      if(Flits('.flits-order-div ul.flits-pagination li:first-child').length){
        Flits('.flits-order-div ul.flits-pagination li:first-child')[0].click();
      }
    }
  });
  Flits(document).on('Flits:AccountPage:Loaded', function(event){
    setTimeout(function(){
      let tempName = Flits('.flits-greeting-text .flits-user-name').text();
      if(tempName){
        let newName = tempName + '!';
        Flits('.flits-greeting-text .flits-user-name').text(newName);
        Flits('.flits-mobile-account-body .flits-user-box .flits-user-name').text(newName);
      }
    }, 3000);
  });
}(Flits));
